import React, { useEffect, useState, useRef } from "react";
import { createPortal } from "react-dom";
import "../../Modules/Tickets/Ticketsadd.css";
import backarrow from "../../Assets/svg/backarrow.svg";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Container, Row, Col, Toast, ToastContainer } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import SearchWithAPI from "../common/searchbox/searchbox.js";
import { format, parse } from "date-fns";
import moment from "moment";
import download from "../../Assets/svg/download.svg";
import set from "../../Assets/svg/set.svg";
import { ReactComponent as ModalCloseIcon } from "../../Assets/svg/close-modal.svg";
import deleteIcon from "../../Assets/svg/delete.svg";
import closeRed from "../../Assets/svg/close-red.svg";
import mergeWarning from "../../Assets/svg/merge_warning.svg";
import arrowDown from "../../Assets/svg/arrow-down.svg";
import arrowUp from "../../Assets/svg/arrow-up.svg";
import clock from "../../Assets/svg/clock.svg";
import clock_color from "../../Assets/svg/clock_color.svg";
import editIcon from "../../Assets/svg/edit.svg";
import LoaderModal from "../common/Loader.js";
import { getAttachmentIcon } from "../common/attachment-icon";
import { getEnabledFieldApi, getApprovalApi } from "./Ticketapi.js";
import BulkEditCard from "../common/bulkEditCard.jsx";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import { marked } from "marked";
import styled from "styled-components";
import { FiCalendar } from "react-icons/fi";
import { apiCall } from "../../services/api-service.js";
const StyledQuill = styled(ReactQuill)`
  .ql-editor {
    min-height: 120px;
    max-height: 200px;
    overflow-y: auto;
  }
  .ql-container {
    padding: 0;
  }
`;
const ExpectedDateCustomInput = React.forwardRef(function ExpectedDateCustomInput({ value, onClick, placeholder }, ref) {
  return (
    <div style={{ position: "relative", width: "100%" }} onClick={onClick}>
      <input ref={ref} value={value} placeholder={placeholder || "Select date & time"} readOnly className="expected-datepicker-input" />
      <FiCalendar
        style={{
          position: "absolute",
          right: "12px",
          top: "50%",
          transform: "translateY(-50%)",
          pointerEvents: "none",
          color: "#546088",
          fontSize: "16px",
        }}
      />
    </div>
  );
});

const Ticketadd = ({ children }) => {
  const apiUrl = process.env.REACT_APP_API_URL;

  const navigate = useNavigate();
  const location = useLocation();
  const { id, parentTicketId, cloneData, quickData, errors, split, mergeTicketIds, mergeData, listing_type } = location.state || {};
  const [mergingTicketsDetails, setMergingTicketsDetails] = useState([]);
  const [showTitleOptions, setShowTitleOptions] = useState(false);
  const [isTitleFocused, setIsTitleFocused] = useState(false);
  const [hoveredTitleIndex, setHoveredTitleIndex] = useState(null);
  const [showMergeConfirm, setShowMergeConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fileName, setFileName] = useState("");
  const [fileBase64, setFileBase64] = useState("");
  const [projectlist, setProjectlist] = useState([]);
  const [modulelist, setModulelist] = useState([]);
  const [componentlist, setComponentlist] = useState([]);
  const [subcomponentlist, setSubcomponentlist] = useState([]);
  const [teamlist, setTeamlist] = useState([]);
  const [emplist, setEmplist] = useState([]);
  const [ticketCode, setTicketCode] = useState("");
  const [title, setTitle] = useState("");
  const [priority, setPriority] = useState("Low");
  const [project, setProject] = useState([]);
  const [module, setModule] = useState([]);
  const [component, setComponent] = useState([]);
  const [subcomponent, setSubcomponent] = useState([]);
  const [description, setDescription] = useState("");
  const [actionPlan, setActionPlan] = useState("");
  const [estimation, setEstimation] = useState("");
  const [lastKey, setLastKey] = useState("");
  const [assignedto, setAssignedto] = useState([]);
  const [createDate, setCreatedate] = useState("");
  const [expectedDate, setExpectedDate] = useState("");
  const [email, setEmail] = useState([]);
  const [team, setTeam] = useState([]);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const [isOpenParentTicket, setIsOpenParentTicket] = useState(false);
  const [parentTicketDetails, setParentTicketDetails] = useState(null);
  const [validations, setValidations] = useState({
    title: "",
    priority: "",
    project_id: "",
    module_id: "",
    component_id: "",
    sub_component_id: "",
    description: "",
    action_plan: "",
    est: "",
    assignee: "",
    created: "",
    expected: "",
    reporter_id: "",
    team_id: "",
    attachments: "",
    reference_id: "",
  });
  const [selectedParentTicketOption, setParentTicketOption] = useState(null);
  const [selectedProjectOption, setProjectOption] = useState(null);
  const [levelOptionList, setLevelOptionList] = useState([{ value: "", label: "" }]);

  const [selectedModuleOption, setModuleOption] = useState(null);
  const [selectedComponentOption, setComponentOption] = useState(null);
  const [selectedSubComponentOption, setSubComponentOption] = useState(null);
  const [selectedAssignToOption, setAssignToOption] = useState(null);
  const [selectedEmailOption, setEmailOption] = useState(null);
  const [selectedTeamOption, setTeamOption] = useState(null);
  const [selectedCustomerOption, setCustomerOption] = useState(null);
  const [selectedReferenceOption, setReferenceOption] = useState(null);
  const [selectedVendorOption, setVendorOption] = useState(null);
  const [moduleSearchUrl, setModuleSearchUrl] = useState("");
  const [componentSearchUrl, setComponentSearchUrl] = useState("");
  const [subComponentSearchUrl, setSubComponentSearchUrl] = useState("");
  const [attachmentURLList, setAttachmentURLList] = useState([]);
  const [attachmentList, setAttachmentList] = useState([]);
  const [previewImageUrl, setPreviewImageUrl] = useState("");
  const [previewImageName, setPreviewImageName] = useState("");
  const [isImagePreviewOpen, setIsImagePreviewOpen] = useState(false);
  const [isApprovalAvail, setisApprovalAvail] = useState(false);
  const [isApprovalSaveAvail, setisApprovalSaveAvail] = useState(false);

  const handleParentTicketDropdownChange = (option) => {
    setParentTicketOption(option);
    getParentTicketDetails(option.value);
    setIsOpenParentTicket(false);
  };
  const handleProjectDropdownChange = (option) => {
    setProjectOption(option);
    setLevelOptionList([{ value: "", label: "" }]);
  };
  useEffect(() => {
    if (selectedProjectOption || levelOptionList) {
      getIsApprovalAvailable();
    }
  }, [selectedProjectOption, levelOptionList]);

  const handleLevelListDropdownChange = (option, onChangeIndex) => {
    const idx = onChangeIndex?.parentIndex ?? 0;
    const tempList = [...levelOptionList].slice(0, idx);

    if (option && option.value) {
      tempList.push(option);
      tempList.push({ value: "", label: "" });
    } else {
      tempList.push({ value: "", label: "" });
    }

    setLevelOptionList(tempList);
  };

  const getLevelParams = (index) => {
    if (index === 0) {
      return {
        project_id: (selectedProjectOption && selectedProjectOption?.value) ?? "",
      };
    } else {
      return {
        parent_id: levelOptionList && levelOptionList[index - 1] != null ? (levelOptionList[index - 1]?.value ?? "") : "",
        project_id: (selectedProjectOption && selectedProjectOption?.value) ?? "",
      };
    }
  };

  const getReferenceParams = () => {
    return {
      customer_id: selectedCustomerOption != null ? selectedCustomerOption.value : "",
    };
  };

  const handleModuleDropdownChange = (option) => {
    setModuleOption(option);
  };
  const handleComponentDropdownChange = (option) => {
    setComponentOption(option);
  };
  const handleSubComponentDropdownChange = (option) => {
    setSubComponentOption(option);
  };
  const handleAssignToDropdownChange = (option) => {
    setAssignToOption(option);
  };
  const handleEmailDropdownChange = (option) => {
    setEmailOption(option);
  };
  const handleTeamDropdownChange = (option) => {
    setTeamOption(option);
    setAssignToOption(null);
  };
  const handleCustomerDropdownChange = async (option) => {
    setCustomerOption(option);
    // Project options are filtered by the selected customer (client_id), so a
    // previously chosen project no longer applies — clear it and its levels.
    setProjectOption(null);
    setLevelOptionList([{ value: "", label: "" }]);

    // If the chosen customer has exactly one project, select it by default.
    const clientId = option?.value;
    if (clientId == null || clientId === "") return;
    try {
      const response = await apiCall("get", "get_project", null, {
        params: { client_id: clientId },
      });
      const projects = response?.data?.suggestionlist ?? [];
      if (projects.length === 1) {
        handleProjectDropdownChange(projects[0]);
      }
    } catch (err) {
      console.error("Error fetching projects for customer:", err);
    }
  };
  const handleRefernceDropdownChange = (option) => {
    setReferenceOption(option);
  };
  const handleVendorDropdownChange = (option) => {
    setVendorOption(option);
  };
  const handleFileChange = (event) => {
    console.log("1...........");
    const inputElement = event.target;
    const file = event.target.files[0];
    console.log("1...........");
    if (file) {
      console.log("2...........");
      /*   setFileName(file.name);  */
      /*  const reader = new FileReader();
       reader.onloadend = () => {
           setFileBase64(reader.result.split(',')[1]);
           setAttachmentList([...attachmentList,{'name':file.name,'base64':reader.result.split(',')[1], 'size':file.size}])
       };
       reader.readAsDataURL(file); */
      const reader = new FileReader();
      reader.onload = async () => {
        const base64String = await reader.result; // this will be the byte code (base64String)
        /*  console.log("Base64 String:", base64String.toString());
         saveAttachment(await reader.result); */
        console.log("3..........");
        setAttachmentList([
          ...attachmentList,
          {
            name: file.name,
            base64: base64String,
            size: formatBytes(file.size),
          },
        ]);
      };
      reader.readAsDataURL(file);
      console.log("4...........");
    }
    // Allow re-selecting the same file name by clearing the input value.
    inputElement.value = "";
  };
  const handleFileChange2 = (event) => {
    const inputElement = event.target;
    const file = event.target.files[0];
    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result;
        setAttachmentList([
          ...attachmentList,
          {
            name: file.name,
            base64: base64String,
            size: formatBytes(file.size),
          },
        ]);
      };
      reader.readAsDataURL(file);
    } else {
      alert("Please select a valid image file.");
    }
    inputElement.value = "";
  };
  const handleDragOver = (event) => {
    event.preventDefault(); // Prevent default behavior (prevent file opening)
  };

  const handleDrop = (event) => {
    event.preventDefault();
    if (event.dataTransfer.files.length > 0) {
      const file = event.dataTransfer.files[0]; // Get the dropped file
      if (file) {
        /*   setFileName(file.name);  */
        /*  const reader = new FileReader();
         reader.onloadend = () => {
             setFileBase64(reader.result.split(',')[1]);
             setAttachmentList([...attachmentList,{'name':file.name,'base64':reader.result.split(',')[1], 'size':file.size}])
         };
         reader.readAsDataURL(file); */
        const reader = new FileReader();
        reader.onload = async () => {
          const base64String = await reader.result; // this will be the byte code (base64String)
          /*  console.log("Base64 String:", base64String.toString());
           saveAttachment(await reader.result); */
          setAttachmentList([
            ...attachmentList,
            {
              name: file.name,
              base64: base64String,
              size: formatBytes(file.size),
            },
          ]);
        };
        reader.readAsDataURL(file);
      }
    }
  };
  const formatBytes = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };
  const alertRef = useRef(null);
  const titleDropdownRef = useRef(null);
  const [alertIndex, setAlertIndex] = useState(null);
  useEffect(() => {
    // Attach event listener to the document
    document.addEventListener("mousedown", handleCloseDialog);
    return () => {
      // Clean up event listener on unmount
      document.removeEventListener("mousedown", handleCloseDialog);
    };
  }, []);
  const handleCloseDialog = (event) => {
    if (alertRef.current && !alertRef.current.contains(event.target)) {
      setAlertIndex(null); // Close the alert
    }
    if (titleDropdownRef.current && !titleDropdownRef.current.contains(event.target)) {
      setShowTitleOptions(false);
    }
  };

  useEffect(() => {
    getEnabledField();
    const now = moment().format("YYYY-MM-DDTHH:mm");
    setCreatedate(now);
    setExpectedDate(now);
    console.log("id........." + id);
    if (id != null && id != undefined) {
      console.log("Changes inside the id", id);
      getTicketDetails();
      getAttachmentList();
    } else if (cloneData != null && cloneData != undefined) {
      fillCloneData(cloneData);
    } else if (quickData != null && quickData != undefined) {
      fillQuickData(quickData);
    } else if (parentTicketId != null && parentTicketId != undefined) {
      console.log("Changes inside the parentTicketId", parentTicketId);
      getParentTicketDetails(parentTicketId);
    } else if (mergeData != null && mergeData != undefined) {
      fillMergeData(mergeData);
    } else {
      getLastTicketDetails("last");
    }
    /*  getProject();
        getModule();
        getComponent();
        getSubcomponent();
        getEmployee();
        getTeam(); */
    if (mergeTicketIds && mergeTicketIds.length > 0) {
      fetchMergingTickets(mergeTicketIds);
    }
  }, []);

  const fetchMergingTickets = async (ids) => {
    setLoading(true);
    try {
      const details = await Promise.all(
        ids.map(async (ticketId) => {
          const response = await apiCall("get", `ticket/edit/${ticketId}`, null, { params: { allow_closed: true } });
          return response?.data?.ticket;
        })
      );
      setMergingTicketsDetails(details.filter((t) => t));
    } catch (error) {
      console.error("Error fetching merging tickets:", error);
    } finally {
      setLoading(false);
    }
  };

  const mapBackendKeyToFrontendKey = (key) => {
    if (key === "estimation") return "est";
    if (key === "assign_to") return "assignee";
    if (key === "expected_date") return "expected";
    if (key === "created_at") return "created";
    return key;
  };

  useEffect(() => {
    if (errors) {
      setValidations((prev) => {
        const validationTemp = { ...prev };
        Object.entries(errors).forEach(([key, value]) => {
          const fieldKey = mapBackendKeyToFrontendKey(key);
          validationTemp[fieldKey] = Array.isArray(value) && value.length > 0 ? value[0] : typeof value === "string" ? value : "";
        });
        return validationTemp;
      });
    }
  }, [errors]);

  const [enabledFields, setEnabledFields] = useState([]);
  const [mandatoryFields, setMandatoryFields] = useState([]);
  const [fieldLabels, setFieldLabels] = useState({});
  // "More Information" card toggle: when on, fields that are not enabled in the
  // configuration are revealed inside the card body (via a portal, so each
  // field keeps its existing JSX and state bindings — no duplication).
  const [showMoreInfo, setShowMoreInfo] = useState(false);
  const [moreInfoNode, setMoreInfoNode] = useState(null);
  const getEnabledField = async () => {
    try {
      const response = await getEnabledFieldApi();
      if (response.success === true) {
        setEnabledFields(response?.enabled_fields ?? []);
        setMandatoryFields(response?.mandatory_fields ?? []);
        setFieldLabels(response?.application_labels ?? response?.labels ?? {});
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getFieldLabel = (fieldKey, defaultLabel = fieldKey) => {
    let custom = fieldLabels?.[fieldKey];
    if ((!custom || typeof custom !== "string" || custom.trim() === "") && (fieldKey === "Customer" || fieldKey === "Client Name")) {
      custom = fieldLabels?.["Customer"] || fieldLabels?.["Client Name"];
    }
    if (custom && typeof custom === "string" && custom.trim() !== "") {
      return custom.trim();
    }
    return defaultLabel;
  };

  const renderFieldLabel = (fieldKey, defaultLabel, extra = null, overrideText = null, isMandatoryExplicit = null) => {
    const labelText = overrideText ?? (fieldKey === "Level" && defaultLabel ? defaultLabel : getFieldLabel(fieldKey, defaultLabel));
    const isMandatory = isMandatoryExplicit !== null ? isMandatoryExplicit : isFieldMandatory(fieldKey);
    return (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          maxWidth: "100%",
          verticalAlign: "middle",
        }}
      >
        <span
          title={labelText}
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            minWidth: 0,
          }}
        >
          {labelText}
        </span>
        {isMandatory && <span style={{ color: "red", marginLeft: "3px", flexShrink: 0 }}> *</span>}
        {extra}
      </span>
    );
  };
  // True only when the field is enabled in the configuration (its normal slot).
  const isFieldConfigured = (field) => {
    if (field === "Customer" || field === "Client Name") {
      return enabledFields.some((item) => item === "Customer" || item === "Client Name");
    }
    return enabledFields.some((item) => item === field);
  };

  const allPotentialFields = [
    "Title",
    "Description",
    "Action Plan",
    "Attachment",
    "Priority",
    "Customer",
    "Vendor",
    "Project",
    "Level",
    "Estimation",
    "Create Date",
    "Expected Date",
    "Reporter",
    "Team",
    "Assign To"
  ];
  const hasUnconfiguredFields = allPotentialFields.some((field) => !isFieldConfigured(field));
  // A field renders in its original position when configured. When NOT
  // configured, it instead renders inside the "More Information" card (only
  // while that card's checkbox is checked).
  const isFieldEnabled = (field) => isFieldConfigured(field);
  const isInMoreInfo = (field) => showMoreInfo && !isFieldConfigured(field);
  const isFieldMandatory = (field) => {
    if (field === "Title" || field === "Project") return true;
    if (!isFieldConfigured(field)) return false;
    if (field === "Customer" || field === "Client Name") {
      return mandatoryFields.some((item) => item === "Customer" || item === "Client Name");
    }
    return mandatoryFields.some((item) => item === field);
  };

  // A card should render only if at least one of its fields is configured —
  // otherwise it would show as an empty white card. (When "More Information" is
  // on, not-configured fields are portaled into that card, not this one, so they
  // don't keep an otherwise-empty card visible.)
  const anyFieldConfigured = (...fields) => fields.some(isFieldConfigured);

  /**
   * Decides where a field (or group) renders: in place when ANY of the given
   * fields is configured; otherwise inside the "More Information" card body (via
   * portal) when that card is checked; otherwise nowhere. The same JSX/state is
   * reused — no duplication.
   *
   * Implemented as a plain function (not a component) so wrapping a field does
   * NOT introduce a new component type each render — that would remount the
   * field's inputs on every keystroke and drop their value.
   */
  const renderField = (field, children) => {
    const fields = Array.isArray(field) ? field : [field];
    if (fields.some(isFieldConfigured)) return children;
    if (showMoreInfo && moreInfoNode) return createPortal(children, moreInfoNode);
    return null;
  };

  const getProject = async () => {
    const response = await apiCall("get", "get_project");
    setProjectlist(response?.data?.suggestionlist ?? []);
  };

  const getModule = async () => {
    const response = await apiCall("get", "get_module");
    setModulelist(response?.data?.suggestionlist ?? []);
  };

  const getComponent = async () => {
    const response = await apiCall("get", "get_component", null, {
      params: { project_id: "" },
    });
    setComponentlist(response?.data?.suggestionlist ?? []);
  };

  const getSubcomponent = async () => {
    const response = await apiCall("get", "get_subcomponent");
    setSubcomponentlist(response?.data?.suggestionlist ?? []);
  };

  const getTeam = async () => {
    const response = await apiCall("get", "get_team");
    setTeamlist(response?.data?.suggestionlist ?? []);
  };

  const getEmployee = async () => {
    const response = await apiCall("get", "get_employee");
    setEmplist(response?.data?.suggestionlist ?? []);
  };
  const getParentTicketDetails = async (parentId) => {
    const response = await apiCall("get", `get_main_ticket/${parentId}`);
    if (response?.status === 200 && response.data?.success === true && response.data?.ticket) {
      setParentTicketDetails(response.data.ticket);
      setisApprovalSaveAvail(response.data.ticket.approval ?? false);
      setParentTicketOption({
        value: response.data.ticket.id,
        label: response.data.ticket.code + "-" + response.data.ticket.title,
      });

      setProjectOption({
        value: response.data.ticket.project_id ?? 0,
        label: response.data.ticket.project ?? 0,
      });
      setAssignToOption({
        value: response.data.ticket.assignee_id ?? 0,
        label: response.data.ticket.assignee ?? 0,
      });
      setTeamOption({
        value: response.data.ticket.team_id ?? 0,
        label: response.data.ticket.team ?? 0,
      });
      setEmailOption({
        value: response.data.ticket.reporter_id ?? 0,
        label: response.data.ticket.reporter_email ?? 0,
      });
      setIsBillingChecked(response.data.ticket.is_billable ?? false);
      if (response.data.ticket.levels && response.data.ticket.levels.length > 0) {
        const tempTempLevels = [...response.data.ticket.levels];
        tempTempLevels.push({ value: "", label: "Select" });
        setLevelOptionList(tempTempLevels);
      } else if (response.data.ticket.component_id) {
        setLevelOptionList([
          {
            value: response.data.ticket.component_id,
            label: response.data.ticket.component || "",
          },
          { value: "", label: "Select" },
        ]);
      }
    }
  };
  const getLastTicketDetails = async (type) => {
    const response = await apiCall("get", "get_last_ticket_data", null, {
      params: { type },
    });
    if (response?.status === 200 && response.data?.success === true && response.data?.data) {
      response.data.data.project &&
        setProjectOption({
          label: response.data.data.project ?? "",
          value: response.data.data.project_id ?? 0,
        });
      response.data.data.reporter &&
        setEmailOption({
          label: response.data.data.reporter ?? "",
          value: response.data.data.reporter_id ?? 0,
        });
      response.data.data.team &&
        setTeamOption({
          label: response.data.data.team ?? "",
          value: response.data.data.team_id ?? 0,
        });
      response.data.data.assignee &&
        setAssignToOption({
          label: response.data.data.assignee ?? "",
          value: response.data.data.assignee_id ?? 0,
        });
    }
  };
  const [isSelfAssignChecked, setIsSelfAssignChecked] = useState(false);
  const getSelfAssignee = async (type) => {
    const response = await apiCall("get", "ticket/get_assignee", null, {
      params: { type },
    });
    if (response?.status === 200 && response.data?.success === true) {
      response.data.data.reporter &&
        setEmailOption({
          label: response.data.data.reporter ?? "",
          value: response.data.data.reporter_id ?? 0,
        });
      response.data.data.team &&
        setTeamOption({
          label: response.data.data.team ?? "",
          value: response.data.data.team_id ?? 0,
        });
      response.data.data.assignee &&
        setAssignToOption({
          label: response.data.data.assignee ?? "",
          value: response.data.data.assignee_id ?? 0,
        });
    }
  };
  const fillCloneData = (resultData) => {
    setTitle(resultData.title ?? "");
    setPriority(resultData.priority ?? "Low");
    setEstimation(resultData.est === "00:00" || resultData.est === "00:00:00" ? "" : (resultData.est?.substring(0, 5) ?? ""));
    setDescription(
      (resultData.description ?? "")
        .replace(/\\r\\n/g, "")
        .replace(/\\r/g, "")
        .replace(/\\n/g, "")
        .replace(/\t/g, "")
        .trim(),
    );
    setActionPlan(
      (resultData.action_plan ?? "")
        .replace(/\\r\\n/g, "")
        .replace(/\\r/g, "")
        .replace(/\\n/g, "")
        .replace(/\t/g, "")
        .trim(),
    );

    const tempTempLevels = resultData.levels.length > 0 ? [...resultData.levels] : [];
    tempTempLevels.push({ value: "", label: "Select" });
    setLevelOptionList(tempTempLevels);
    resultData.project_id &&
      setProjectOption({
        value: resultData.project_id,
        label: resultData.project ?? "",
      });
    resultData.assignee_id &&
      setAssignToOption({
        value: resultData.assignee_id,
        label: resultData.assignee ?? "",
      });
    resultData.reporter_id &&
      setEmailOption({
        value: resultData.reporter_id,
        label: resultData.reporter_email ?? "",
      });
    resultData.team_id &&
      setTeamOption({
        value: resultData.team_id,
        label: resultData.team ?? "",
      });
    resultData.customer_id &&
      setCustomerOption({
        value: resultData.customer_id,
        label: resultData.customer ?? "",
      });
    resultData.reference_value &&
      setReferenceOption({
        value: resultData.reference_value,
        label: resultData.reference ?? "",
      });
    resultData.vendor_id &&
      setVendorOption({
        value: resultData.vendor_id,
        label: resultData.vendor ?? "",
      });
    setIsBillingChecked(resultData.is_billable);
    setAttachmentURLList(resultData.attachments ?? []);
  };

  const fillMergeData = (data) => {
    if (data.estimation) setEstimation(data.estimation);
    if (data.action_plan) setActionPlan(data.action_plan);
    if (data.created_date) setCreatedate(moment(data.created_date).format("YYYY-MM-DDTHH:mm"));
    if (data.expected_date) setExpectedDate(moment(data.expected_date).format("YYYY-MM-DDTHH:mm"));
    if (Array.isArray(data.attachments) && data.attachments.length > 0) {
      setAttachmentList(
        data.attachments.map((att) => ({
          name: att.name,
          base64: att.base64,
          size: att.size || "0 Bytes",
        }))
      );
    }
  };

  const fillQuickData = (data) => {
    setTitle(data.title ?? "");
    setDescription(data.description ?? "");
    if (data.action_plan) setActionPlan(data.action_plan);
    data.project && setProjectOption(data.project);
    data.assignee && setAssignToOption(data.assignee);
    data.reporter && setEmailOption(data.reporter);
    data.team && setTeamOption(data.team);
    data.priority && setPriority(data.priority);
  };

  const getTicketDetails = async () => {
    setLoading(true);
    try {
      const response = await apiCall("get", `ticket/edit/${id}`);
      if (response?.status === 200 && response.data?.success === true) {
        var resultData = response.data.ticket;
        setTicketCode(resultData.code ?? "");
        setTitle(resultData.title ?? "");
        setPriority(resultData.priority ?? "Low");
        setEstimation(resultData.est === "00:00" || resultData.est === "00:00:00" ? "" : (resultData.est?.substring(0, 5) ?? ""));
        setCreatedate(resultData.created ?? "");
        setExpectedDate(resultData.expected ?? "");

        setDescription(
          (resultData.description ?? "")
            .replace(/\\r\\n/g, "")
            .replace(/\\r/g, "")
            .replace(/\\n/g, "")
            .replace(/\t/g, "")
            .trim(),
        );
        setActionPlan(
          (resultData.action_plan ?? "")
            .replace(/\\r\\n/g, "")
            .replace(/\\r/g, "")
            .replace(/\\n/g, "")
            .replace(/\t/g, "")
            .trim(),
        );

        const tempTempLevels = resultData.levels.length > 0 ? [...resultData.levels] : [];
        tempTempLevels.push({ value: "", label: "Select" });
        setLevelOptionList(tempTempLevels);
        resultData.project_id &&
          setProjectOption({
            value: resultData.project_id??'',
            label: resultData.project ?? "",
          });
        resultData.module_id &&
          setModuleOption({
            value: resultData.module_id??'',
            label: resultData.module ?? "",
          });
        resultData.component_id &&
          setComponentOption({
            value: resultData.component_id??'',
            label: resultData.component ?? "",
          });
        resultData.sub_component_id &&
          setSubComponentOption({
            value: resultData.sub_component_id??'',
            label: resultData.sub_component ?? "",
          });
        resultData.assignee_id &&
          setAssignToOption({
            value: resultData.assignee_id??'',
            label: resultData.assignee ?? "",
          });
        resultData.reporter_id &&
          setEmailOption({
            value: resultData.reporter_id??'',
            label: resultData.reporter_email ?? "",
          });
        resultData.team_id &&
          setTeamOption({
            value: resultData.team_id??'',
            label: resultData.team ?? "",
          });
        resultData.customer_id &&
          setCustomerOption({
            value: resultData.customer_id??'',
            label: resultData.customer ?? "",
          });

        resultData.vendor_id &&
          setVendorOption({
            value: resultData.vendor_id??'',
            label: resultData.vendor ?? "",
          });
           resultData.reference_value &&
          setReferenceOption({
            value: resultData.reference_value??'',
            label: resultData.reference ?? "",
          });
        setIsBillingChecked(resultData.is_billable);
      }
    } finally {
      setLoading(false);
    }
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {
      title: "",
      priority: "",
      project_id: "",
      module_id: "",
      component_id: "",
      sub_component_id: "",
      reference_id: "",
      description: "",
      est: "",
      assignee: "",
      created: "",
      expected: "",
      reporter_id: "",
      team_id: "",
      attachments: "",
    };

    if (isFieldMandatory("Title") && !title?.trim()) {
      newErrors.title = "The title field is required.";
      isValid = false;
    }
    if (isFieldMandatory("Description") && !description?.trim()) {
      newErrors.description = "The description field is required.";
      isValid = false;
    }
    if (isFieldMandatory("Action Plan") && (!actionPlan || !actionPlan.replace(/<(.|\n)*?>/g, "").trim())) {
      newErrors.action_plan = "The action plan field is required.";
      isValid = false;
    }
    if (isFieldMandatory("Priority") && !priority) {
      newErrors.priority = "The priority field is required.";
      isValid = false;
    }
    if (isFieldMandatory("Project") && (!selectedProjectOption || !selectedProjectOption.value)) {
      newErrors.project_id = "The project id field is required.";
      isValid = false;
    }
    if (isFieldEnabled("Level") && isFieldMandatory("Level") && (!levelOptionList || levelOptionList.length === 0 || !levelOptionList[0]?.value)) {
      newErrors.component_id = "The component id field is required.";
      isValid = false;
    }
    if (isFieldMandatory("Estimation")) {
      if (!estimation) {
        newErrors.est = "The estimation field is required.";
        isValid = false;
      } else if (!/^([0-9]+):([0-5]?[0-9])$/.test(estimation) || ["00:00", "0:00", "0:0", "00:0"].includes(estimation)) {
        newErrors.est = "The selected estimation is not valid.";
        isValid = false;
      }
    } else {
      if (estimation && (!/^([0-9]+):([0-5]?[0-9])$/.test(estimation) || ["00:00", "0:00", "0:0", "00:0"].includes(estimation))) {
        newErrors.est = "The selected estimation is not valid.";
        isValid = false;
      }
    }
    if (isFieldMandatory("Create Date") && !createDate) {
      newErrors.created = "The created at field is required.";
      isValid = false;
    }
    if (isFieldMandatory("Expected Date") && !expectedDate) {
      newErrors.expected = "The expected date field is required.";
      isValid = false;
    }
    if (isFieldMandatory("Reporter") && (!selectedEmailOption || !selectedEmailOption.value)) {
      newErrors.reporter_id = "The reporter id field is required.";
      isValid = false;
    }
    if (isFieldMandatory("Team") && (!selectedTeamOption || !selectedTeamOption.value)) {
      newErrors.team_id = "The team id field is required.";
      isValid = false;
    }
    if (isFieldMandatory("Assign To") && (!selectedAssignToOption || !selectedAssignToOption.value)) {
      newErrors.assignee = "The assign to field is required.";
      isValid = false;
    }

    setValidations(newErrors);
    return isValid;
  };

  const taskSubmit = async (isConfirmed = false) => {
    if (mergeTicketIds && mergeTicketIds.length > 0 && !isConfirmed) {
      if (!validateForm()) {
        return;
      }
      setShowMergeConfirm(true);
      return;
    }
    setLoading(true);
    try {
      setValidations({
        title: "",
        priority: "",
        project_id: "",
        module_id: "",
        component_id: "",
        sub_component_id: "",
        reference_id: "",
        description: "",
        action_plan: "",
        est: "",
        assignee: "",
        created: "",
        expected: "",
        reporter_id: "",
        team_id: "",
        attachments: "",
      });

      if (split && parentTicketDetails) {
        const timeToMin = (t) => {
          if (!t) return 0;
          const parts = t.split(":");
          return parseInt(parts[0] || 0) * 60 + parseInt(parts[1] || 0);
        };
        const parentMinutes = timeToMin(parentTicketDetails.est);
        const splitMinutes = timeToMin(estimation);

        if (splitMinutes > parentMinutes) {
          setValidations((prev) => ({ ...prev, est: `Duration cannot exceed parent estimation (${parentTicketDetails.est?.substring(0, 5)})` }));
          setLoading(false);
          return;
        }
      }

      const requestBody = {
        title: title,
        priority: priority,
        project_id: selectedProjectOption != null ? selectedProjectOption.value : "",
        levels: (levelOptionList || []).filter((item) => item && item?.value !== "").map((item) => item.value),
        /* module_id: selectedModuleOption!=null?selectedModuleOption.value:'', */
        component_id: levelOptionList && levelOptionList.length > 0 && levelOptionList[0]?.value ? levelOptionList[0].value : "",
        /* sub_component_id: selectedSubComponentOption!=null?selectedSubComponentOption.value:'', */
        description: description,
        action_plan: actionPlan,
        estimation: estimation,
        assign_to: selectedAssignToOption != null ? selectedAssignToOption.value : "",
        created_at: createDate,
        expected_date: expectedDate,
        reporter_id: selectedEmailOption != null ? selectedEmailOption.value : "",
        team_id: selectedTeamOption != null ? selectedTeamOption.value : "",

        is_billable: isBillingChecked,
        customer_id: selectedCustomerOption != null ? selectedCustomerOption.value : "",
        reference_id: selectedReferenceOption != null ? selectedReferenceOption.value : "",
        vendor_id: selectedVendorOption != null ? selectedVendorOption.value : "",
        approval: isApprovalSaveAvail ?? false,
        attachments: attachmentList.length > 0 ? attachmentList : [],
        ticket_ids: mergingTicketsDetails.map((t) => t.id),
        module_id: selectedModuleOption != null ? selectedModuleOption.value : "",
      };
      const isNew = id === null || id === undefined;
      const isMerge = mergeTicketIds && mergeTicketIds.length > 0;
      const endpoint = split ? "ticket/split" : isMerge ? "ticket/merge" : isNew ? "ticket" : `ticket/${id}`;
      if (split || parentTicketId || selectedParentTicketOption?.value) {
        const pId = selectedParentTicketOption?.value || parentTicketId;
        requestBody["parent_id"] = pId;
        requestBody["main_ticket_id"] = pId;
        requestBody["is_sub"] = true;
        requestBody["is_subticket"] = true;
      }
      if (!split && !isMerge) {
        requestBody["assignee"] = requestBody.assign_to;
        requestBody["est"] = requestBody.estimation;
        requestBody["created"] = requestBody.created_at;
        requestBody["expected"] = requestBody.expected_date;
        requestBody["attachments"] = attachmentList.length;
      }
      if (isMerge) {
        requestBody["component_id"] = levelOptionList && levelOptionList.length > 0 && levelOptionList[0]?.value ? levelOptionList[0].value : "";
        requestBody["sub_component_id"] = levelOptionList && levelOptionList.length > 1 && levelOptionList[1]?.value ? levelOptionList[1].value : "";
      }

      const response = await apiCall(split ? "post" : isMerge ? "post" : isNew ? "post" : "put", endpoint, requestBody);

      if (response?.status === 200 && response.data?.success === true) {
        if (attachmentList.length > 0) {
          await Promise.all(attachmentList.map((attachment) => saveAttachment(response.data.id, attachment)));
        }
        responseSuccess(response.data);
      } else if (response?.status === 400 && response.data?.error) {
        const validationTemp = { ...validations };
        Object.keys(validationTemp).forEach((key) => {
          validationTemp[key] = "";
        });
        Object.entries(response.data.error).forEach(([key, value]) => {
          const mappedKey = mapBackendKeyToFrontendKey(key);
          validationTemp[mappedKey] = value.length === 0 ? "" : value[0];
        });
        setValidations(validationTemp);
      } else {
        responseFailure(response?.data ?? { message: "Something went wrong", success: false });
      }
    } finally {
      setLoading(false);
    }
  };
  const responseSuccess = (data) => {
    setSnackbarMessage(data.message);
    setSnackbarStatus(data.success);
    handleSnackbarShow();

    const empId = data.emp_id;
    const reporterId = data.reporter_id;
    const assignToId = data.assign_to;

    let targetTab = "tickets";
    if (assignToId === empId) {
      targetTab = "assigned_me";
    } else if (reporterId === empId) {
      targetTab = "my_tickets";
    }

    navigate("/ticket", { state: { listing_type: targetTab, parentTicketId: parentTicketId || selectedParentTicketOption?.value } });
  };
  const responseFailure = (data) => {
    setSnackbarMessage(data.message);
    setSnackbarStatus(data.success);
    handleSnackbarShow();
  };

  function formatDateTime(inputDate) {
    console.log("inputDate...........", inputDate);
    try {
      if (inputDate !== undefined) {
        /* // Parse the input date (MM/DD/YYYY format)
        const parsedDate = parse(inputDate, 'MM/dd/yyyy', new Date());
            console.log('parsedDate...........',parsedDate);
        // Format the date
        return format(parsedDate, "yyyy-MM-dd"); */
        return moment(inputDate).format("yyyy-MM-ddThh:mm");
      } else {
        return "";
      }
    } catch (err) {
      console.error("Error fetching options:", err);
    } finally {
    }
  }
  function formatDate(inputDate) {
    console.log("inputDate...........", inputDate);
    try {
      if (inputDate !== undefined) {
        /* // Parse the input date (MM/DD/YYYY format)
        const parsedDate = parse(inputDate, 'MM/dd/yyyy', new Date());
            console.log('parsedDate...........',parsedDate);
        // Format the date
        return format(parsedDate, "yyyy-MM-dd"); */
        return moment(inputDate).format("YYYY-MM-DDTHH:mm");
      } else {
        return "";
      }
    } catch (err) {
      console.error("Error fetching options:", err);
    } finally {
    }
  }

  const getExpectedDateFromCreateAndEstimation = (createdDateValue, estimationValue) => {
    if (!createdDateValue || !estimationValue) {
      return "";
    }

    const match = estimationValue.match(/^(\d{1,2}):(\d{1,2})$/);
    if (!match) {
      return "";
    }

    const hours = Number(match[1]);
    const minutes = Number(match[2]);
    if (Number.isNaN(hours) || Number.isNaN(minutes) || minutes > 59) {
      return "";
    }

    const createdMoment = moment(createdDateValue, "YYYY-MM-DDTHH:mm", true);
    if (!createdMoment.isValid()) {
      return "";
    }

    return createdMoment.clone().add(hours, "hours").add(minutes, "minutes").format("YYYY-MM-DDTHH:mm");
  };

  const handleCreateDateChange = (date) => {
    const newCreateDate = date ? moment(date).format("YYYY-MM-DDTHH:mm") : "";

    setCreatedate(newCreateDate);

    // Always recalculate Expected Date when Created Date changes
    const calculatedExpected = getExpectedDateFromCreateAndEstimation(newCreateDate, estimation);
    if (calculatedExpected) {
      setExpectedDate(calculatedExpected);
      return;
    }

    // update expectedDate only if createdDate > expectedDate
    if (newCreateDate && expectedDate && moment(newCreateDate).isAfter(moment(expectedDate))) {
      setExpectedDate(newCreateDate);
    }
  };

  const handleExpectedDateChange = (date) => {
    if (date && createDate && moment(date).isSameOrBefore(moment(createDate))) {
      setValidations((prev) => ({ ...prev, expected: "" }));
      setExpectedDate(moment(createDate).format("YYYY-MM-DDTHH:mm"));
      return;
    }
    setValidations((prev) => ({ ...prev, expected: "" }));
    setExpectedDate(date ? moment(date).format("YYYY-MM-DDTHH:mm") : "");
  };

  const downloadFile = (fileUrl, fileName) => {
    fetch(fileUrl)
    
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => console.error("Download error:", error));
  };

  const isImageAttachment = (attachment) => {
    const mimeType = (attachment?.mime_type ?? attachment?.content_type ?? attachment?.type ?? "").toString().toLowerCase();

    if (mimeType.startsWith("image/")) {
      return true;
    }

    const fileSource = (attachment?.name ?? attachment?.url ?? attachment?.base64 ?? "").toString().toLowerCase().split("?")[0].split("#")[0];

    const extension = fileSource.includes(".") ? fileSource.substring(fileSource.lastIndexOf(".") + 1) : "";

    return ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg"].includes(extension);
  };

  const openImagePreview = (attachment) => {
    const source = attachment?.url || attachment?.base64 || "";
    if (!source || !isImageAttachment(attachment)) {
      return;
    }

    setPreviewImageUrl(source);
    setPreviewImageName(attachment?.name ?? "Attachment Image");
    setIsImagePreviewOpen(true);
  };

  const closeImagePreview = () => {
    setIsImagePreviewOpen(false);
    setPreviewImageUrl("");
    setPreviewImageName("");
  };

  const getAttachmentList = async () => {
    const response = await apiCall("get", `ticket/attachment/${id}`);
    if (response?.status === 200 && response.data?.success === true) {
      setAttachmentURLList(response.data.attachments ?? []);
    }
  };
  const getIsApprovalAvailable = async () => {
    const body = {
      project_id: selectedProjectOption?.value ?? "",
      component_id: levelOptionList && levelOptionList.length > 0 && levelOptionList[0]?.value ? levelOptionList[0].value : "",
    };

    try {
      const response = await getApprovalApi(body); // pass body if API expects it
      console.log("Approval API response:", response);
      if (response?.success === true) {
        setisApprovalAvail(response.approval_avail ?? false);
      }
    } catch (error) {
      if (error.response) {
        console.error("Error Status:", error.response.status);
        console.error("Error Data:", error.response.data);
        if (error.response.status === 400) {
          // handle 400
        }
      } else {
        console.error("Error fetching category:", error);
      }
    }
  };

  const saveAttachment = async (attachmentId, attachment) => {
    const data = {
      attachment: attachment.base64,
      attachment_name: attachment.name,
    };
    return apiCall("put", `ticket/add_attachment/${attachmentId}`, data);
  };
  const removeAttachment = async (attachmentId) => {
    const response = await apiCall("put", `ticket/remove_attachment/${attachmentId}`, {});
    if (response?.status === 200 && response.data?.success === true) {
      setAlertIndex(null);
      getAttachmentList();
      setSnackbarMessage(response.data.message);
      setSnackbarStatus(response.data.success);
      handleSnackbarShow();
    } else {
      setSnackbarMessage(response?.data?.message ?? "Something went wrong");
      setSnackbarStatus(false);
      handleSnackbarShow();
    }
  };
  const parentTicketModalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "#ffffff",
      padding: "16px 24px",
      borderRadius: "16px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      width: "600px",

      textAlign: "center",
    },
  };
  const closePatentTicketModal = () => {
    setIsOpenParentTicket(false);
  };
  const [isBillingChecked, setIsBillingChecked] = useState(false);
  const handleCheckboxChange = (e) => {
    // Check if the target element is available before accessing its value
    if (e.target) {
      setIsBillingChecked(e.target.checked);
    }
  };
  const handleApprovCheckboxChange = (e) => {
    // Check if the target element is available before accessing its value
    if (e.target) {
      setisApprovalSaveAvail(e.target.checked);
    }
  };
  return (
    <Container fluid style={{ width: "100%", padding: "0px", paddingBottom: "20px" }}>
      <div className="d-flex side4">
        <Row
          sm={12}
          style={{
            "--bs-gutter-x": "0px",
            margin: "0px",
            width: "100%",
            // height: "100vh",
            overflow: "visible",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            justifyContent: "center",
          }}
        >
          <Col>
            <div className="maincontent4">
              <Row
                xs={12}
                style={{
                  backgroundColor: "#F3F6F9",
                  padding: "16px 16px 0px 16px",
                }}
              >
                <Col sm={6}>
                  <div className="p14 d-flex justify-content-between">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Link to="/ticket">
                        <img
                          src={backarrow}
                          style={{
                            width: "16px",
                            height: "10px",
                            margin: "0",
                          }}
                        />
                      </Link>
                      <p
                        style={{
                          margin: "0",
                          marginLeft: "15px",
                          fontFamily: "Satoshi",
                          fontSize: "16px",
                          fontWeight: "700",
                          lineHeight: "21.6px",
                          color: "#212129",
                          marginTop: "4px",
                          marginRight: "8px",
                        }}
                      >
                        {split ? "Split Ticket" : (mergeTicketIds ? "Merge Ticket" : (selectedParentTicketOption === null ? (id != null && id !== undefined ? ticketCode : "Create Ticket") : selectedParentTicketOption.label))}{" "}
                      </p>
                      {split && parentTicketDetails && (
                        <>
                          <div style={{ color: "#D9D9D9", margin: "0 8px", fontSize: "16px" }}>•</div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              height: "38px",
                              padding: "6px 10px",
                              background: "#FFFFFF",
                              borderRadius: "10px",
                              border: "1px solid #E5E5E5",
                            }}
                          >
                            <span style={{ color: "#6929E2", fontWeight: "700", marginRight: "8px", fontSize: "14px" }}>|</span>
                            <span style={{ fontFamily: "Satoshi", fontWeight: "500", fontSize: "13px", lineHeight: "100%", color: "#212129", marginRight: "4px" }}>{parentTicketDetails.code}</span>
                            <span style={{ color: "#212129", marginRight: "4px" }}>-</span>
                            <span
                              style={{
                                fontFamily: "Satoshi",
                                fontWeight: "500",
                                fontSize: "14px",
                                lineHeight: "100%",
                                color: "#212129",
                                maxWidth: "350px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                              title={`${parentTicketDetails.code} - {parentTicketDetails.title}`}
                            >
                              {parentTicketDetails.title}
                            </span>
                            <div style={{ color: "#D9D9D9", margin: "0 8px", fontSize: "14px" }}>•</div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                                background: "#F2EBFF",
                                padding: "4px 10px",
                                borderRadius: "100px",
                              }}
                            >
                              <img src={clock_color} alt="clock" style={{ width: "12px", height: "12px" }} />
                              <span style={{ fontSize: "12px", fontWeight: "700", color: "#6929E2", fontFamily: "Satoshi", lineHeight: "100%" }}>{parentTicketDetails.est?.substring(0, 5)}</span>
                            </div>
                          </div>
                        </>
                      )}
                      {!split && selectedParentTicketOption !== null && (
                        <div
                          onClick={() => {
                            setIsOpenParentTicket(true);
                          }}
                          style={{
                            width: "32px",
                            height: "32px",
                            borderRadius: "100px",
                            background: "#ffffff",
                            border: "0.7px solid #E5E5E5",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: "4px",
                          }}
                        >
                          <img src={editIcon} style={{ width: "14px", height: "14px" }} alt="Edit" />
                        </div>
                      )}
                      {!split && selectedParentTicketOption !== null && (
                        <div
                          onClick={() => {
                            setParentTicketOption(null);
                            setParentTicketDetails(null);
                            setModuleOption(null);
                            setIsBillingChecked(false);
                          }}
                          style={{
                            width: "32px",
                            height: "32px",
                            borderRadius: "100px",
                            background: "#ffffff",
                            border: "0.7px solid #E5E5E5",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <img src={deleteIcon} style={{ width: "14px", height: "14px" }} alt="Remove" />
                        </div>
                      )}
                    </div>
                  </div>
                </Col>
                <Col sm={6}>
                  <div style={{ display: "flex", justifyContent: "end" }}>
                    <div
                      onClick={() => {
                        navigate(-1);
                      }}
                      style={{
                        height: "40px",
                        borderRadius: "100px",
                        border: "0.6px solid #E5E5E5",
                        padding: "10px 28px 10px 28px",
                        gap: "10px",
                        backgroundColor: "#FFFFFF",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginRight: "12px",
                        cursor: "pointer",
                      }}
                    >
                      <p
                        style={{
                          fontFamily: "Satoshi",
                          fontSize: "14px",
                          fontWeight: "700",
                          lineHeight: "18.9px",
                          margin: "0",
                          color: "#212172C",
                        }}
                      >
                        Cancel
                      </p>
                    </div>

                    <button
                      style={{
                        height: "40px",
                        borderRadius: "100px",
                        padding: "10px 28px 10px 28px",
                        gap: "10px",
                        backgroundColor: "#3253EB",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        fontFamily: "Satoshi",
                        fontSize: "14px",
                        fontWeight: "700",
                        lineHeight: "18.9px",
                        color: "#FFFFFF",
                        border: "none",
                        marginLeft: "12px",
                      }}
                      onClick={() => !loading && taskSubmit()}
                    >
                      {mergeTicketIds ? "Merge & Save" : "Save"}
                    </button>
                  </div>
                </Col>
              </Row>
              <Col
                style={{
                  padding: "16px",
                  paddingTop: "0px",
                  height: "auto",
                  overflow: "visible",
                  justifyContent: "center",
                }}
                xs={12}
                className="maincontent4"
              >
                <Row xs={12} className="align-items-stretch">
                  <Col md={12} lg={6}>
                  {(() => {
                    const fields = (
                      <>
                        {renderField("Title", (
                          <div style={{ marginBottom: "16px" }}>
                            <p
                              style={{
                                fontFamily: "Satoshi",
                                fontSize: "13px",
                                fontWeight: "500",
                                lineHeight: "17.55px",
                                color: "#212129",
                                marginBottom: "8px",
                                maxWidth: "100%",
                              }}
                            >
                              {renderFieldLabel("Title", "Task Title")}
                            </p>
                            <div ref={titleDropdownRef} style={{ position: "relative" }}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  height: "44px",
                                  borderRadius: "10px",
                                  border: isTitleFocused || showTitleOptions ? "1px solid #6929E2" : "1px solid #E5E5E5",
                                  background: "#FFFFFF",
                                  overflow: "hidden",
                                }}
                              >
                                <input
                                  id="title"
                                  className="form-control"
                                  value={title}
                                  onChange={(event) => {
                                    setTitle(event.target.value);
                                  }}
                                  onFocus={() => {
                                    setShowTitleOptions(true);
                                    setIsTitleFocused(true);
                                  }}
                                  onBlur={() => setIsTitleFocused(false)}
                                  style={{
                                    flex: 1,
                                    border: "none",
                                    height: "100%",
                                    padding: "0 16px",
                                    fontFamily: "Satoshi",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                    color: "#21272C",
                                    background: "transparent",
                                    boxShadow: "none",
                                  }}
                                  placeholder="Enter title here..."
                                />
                                {mergingTicketsDetails.length > 0 && (
                                  <>
                                    <div style={{ width: "1px", height: "100%", background: isTitleFocused || showTitleOptions ? "#6929E2" : "#E5E5E5" }}></div>
                                    <div
                                      style={{
                                        width: "44px",
                                        height: "100%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => setShowTitleOptions(!showTitleOptions)}
                                    >
                                      <img src={showTitleOptions ? arrowUp : arrowDown} alt="arrow" style={{ width: "12px" }} />
                                    </div>
                                  </>
                                )}
                              </div>

                              {showTitleOptions && mergingTicketsDetails.length > 0 && (
                                <div
                                  style={{
                                    position: "absolute",
                                    top: "calc(100% + 4px)",
                                    left: 0,
                                    right: 0,
                                    background: "#FFFFFF",
                                    border: "1px solid #E5E5E5",
                                    borderRadius: "10px",
                                    zIndex: 10,
                                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                  }}
                                >
                                  {mergingTicketsDetails.map((ticket, i) => (
                                    <div
                                      key={i}
                                      onMouseEnter={() => setHoveredTitleIndex(i)}
                                      onMouseLeave={() => setHoveredTitleIndex(null)}
                                      style={{
                                        padding: "12px 16px",
                                        cursor: "pointer",
                                        fontFamily: "Satoshi",
                                        fontSize: "14px",
                                        color: "#212129",
                                        backgroundColor: hoveredTitleIndex === i ? "#F9F6FF" : "#FFFFFF",
                                        borderBottom: i === mergingTicketsDetails.length - 1 ? "none" : "1px solid #F3F4F6",
                                      }}
                                      onClick={() => {
                                        setTitle(ticket.title);
                                        setShowTitleOptions(false);
                                      }}
                                      onMouseDown={(e) => e.preventDefault()}
                                    >
                                      {ticket.title}
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                            <span
                              style={{
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "#FF4444",
                              }}
                            >
                              {validations.title}
                            </span>
                          </div>
                        ))}
                        {renderField("Description", (
                          <Col xs={12} style={{ marginTop: "16px" }}>
                            <div style={{ gap: "24px" }}>
                              <p
                                style={{
                                  fontFamily: "Satoshi",
                                  fontSize: "16px",
                                  fontWeight: "700",
                                  lineHeight: "21.6px",
                                  color: "#212129",
                                  maxWidth: "100%",
                                }}
                              >
                                {renderFieldLabel("Description", "Description")}
                              </p>
                            </div>
                            <StyledQuill value={description} onChange={setDescription} />
                            {/* <ReactQuill
                            theme="snow"
                            style={{ color: "#212129", minHeight: "150px" }}
                            value={description}
                            onChange={setDescription}
                          /> */}
                            {/* <textarea
                            className="w-100"
                            id="description"
                            value={description}
                            onChange={(event) => {
                              setDescription(event.target.value);
                            }}
                            style={{
                              height: "140px",
                              borderRadius: "10px",
                              border: "0.7px solid #E5E5E5",
                              backgroundColor: "#FFFFFF",
                              padding: "12px 16px 12px 16px",
                              gap: "77px",
                              fontFamily: "Satoshi",
                              fontSize: "14px",
                              fontWeight: "500",
                              lineHeight: "18.9px",
                            }}
                            placeholder="Type something here..."
                          ></textarea> */}
                            <span
                              style={{
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "#FF4444",
                              }}
                            >
                              {validations.description}
                            </span>
                            {mergingTicketsDetails.length > 0 && (
                              <div style={{ marginTop: "24px" }}>
                                <p
                                  style={{
                                    fontFamily: "Satoshi",
                                    fontSize: "12px",
                                    fontWeight: "700",
                                    lineHeight: "16.2px",
                                    color: "#81878C",
                                    marginBottom: "12px",
                                    textTransform: "uppercase",
                                  }}
                                >
                                  MERGING TICKETS
                                </p>
                                {mergingTicketsDetails.map((ticket, index) => (
                                  <div
                                    key={index}
                                    style={{
                                      height: "44px",
                                      background: "#F9F6FF",
                                      borderRadius: "10px",
                                      padding: "12px 16px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                      marginBottom: "8px",
                                      border: "1px solid #F3F4F6",
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontFamily: "Satoshi",
                                        fontSize: "14px",
                                        fontWeight: "500",
                                        color: "#212129",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                      }}
                                    >
                                      {ticket.code} - {ticket.title}
                                    </span>
                                    <div
                                      style={{
                                        width: "24px",
                                        height: "24px",
                                        borderRadius: "100px",
                                        border: "1px solid #E5E5E5",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        cursor: "pointer",
                                        backgroundColor: "#FFFFFF",
                                      }}
                                      onClick={() => {
                                        const updatedList = mergingTicketsDetails.filter((_, i) => i !== index);

                                        if (updatedList.length === 0) {
                                          navigate("/ticket", { state: { listing_type: listing_type || "assigned_me" } });
                                          return;
                                        }

                                        setMergingTicketsDetails(updatedList);

                                        const parseToSeconds = (timeStr) => {
                                          if (!timeStr || timeStr === "--:--") return 0;
                                          const parts = String(timeStr).split(":").map(Number);
                                          if (parts.length === 3) return parts[0] * 3600 + parts[1] * 60 + parts[2];
                                          if (parts.length === 2) return parts[0] * 3600 + parts[1] * 60;
                                          return 0;
                                        };

                                        const formatToHHMM = (totalSeconds) => {
                                          const hours = Math.floor(totalSeconds / 3600);
                                          const minutes = Math.floor((totalSeconds % 3600) / 60);
                                          return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
                                        };

                                        let totalSeconds = 0;
                                        updatedList.forEach((t) => {
                                          totalSeconds += parseToSeconds(t.est);
                                          totalSeconds += parseToSeconds(t.work_duration || t.duration);
                                        });

                                        setEstimation(formatToHHMM(totalSeconds));
                                      }}
                                    >
                                      <img src={closeRed} alt="remove" style={{ width: "10px", height: "10px" }} />
                                    </div>
                                  </div>
                                ))}
                              </div>
                            )}
                          </Col>
                        ))}
                        {renderField("Action Plan", (
                          <Col xs={12} style={{ marginTop: "16px" }}>
                            <div style={{ gap: "24px" }}>
                              <p
                                style={{
                                  fontFamily: "Satoshi",
                                  fontSize: "16px",
                                  fontWeight: "700",
                                  lineHeight: "21.6px",
                                  color: "#212129",
                                  maxWidth: "100%",
                                }}
                              >
                                {renderFieldLabel("Action Plan", "Action Plan")}
                              </p>
                            </div>
                            <StyledQuill value={actionPlan} onChange={setActionPlan} />
                            <span
                              style={{
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "#FF4444",
                              }}
                            >
                              {validations.action_plan}
                            </span>
                          </Col>
                        ))}
                      </>
                    );

                    if (anyFieldConfigured("Title", "Description", "Action Plan")) {
                      return (
                        <div
                          style={{
                            borderRadius: "16px",
                            padding: "16px",
                            backgroundColor: "#FFFFFF",
                            marginTop: "16px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <p
                              style={{
                                fontFamily: "Satoshi",
                                fontSize: "16px",
                                fontWeight: "700",
                                lineHeight: "21.6px",
                                color: "#212129",
                                marginBottom: "24px",
                              }}
                            >
                              {parentTicketDetails != null ? "Sub " : ""}Ticket Details{" "}
                            </p>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                textAlign: "center",
                              }}
                            >
                              {(id === null || id === undefined) && selectedParentTicketOption === null && mergingTicketsDetails.length === 0 && (
                                <div
                                  onClick={() => {
                                    setIsOpenParentTicket(true);
                                  }}
                                  style={{
                                    margin: "0",
                                    height: "36px",
                                    borderRadius: "8px",
                                    padding: "10px 16px 10px 16px",
                                    gap: "8px",
                                    backgroundColor: "#EBEEFF",
                                    cursor: "pointer",
                                  }}
                                >
                                  <p
                                    style={{
                                      fontFamily: "Satoshi",
                                      fontSize: "13px",
                                      lineHeight: "17.55px",
                                      fontWeight: "700px",
                                      color: "#212129",
                                    }}
                                  >
                                    + Sub Ticket
                                  </p>
                                </div>
                              )}
                            </div>
                          </div>
                          {fields}
                        </div>
                      );
                    }
                    return fields;
                  })()}
                    {/* {renderField(["Customer", "Vendor"], (<>
                      <div
                        style={{
                          borderRadius: "16px",
                          padding: "16px",
                          gap: "24px",
                          backgroundColor: "#FFFFFF",
                          marginTop: "16px",
                          cursor: "pointer",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <div
                            onClick={() => {
                              parentTicketDetails == null && setIsBillingChecked(!isBillingChecked);
                            }}
                            style={{
                              fontFamily: "Satoshi",
                              fontSize: "16px",
                              fontWeight: "900",
                              lineHeight: "21.6px",
                              color: "#212129",
                            }}
                          >
                            Is this ticket for billing?
                          </div>
                          <div>
                            <input type="checkbox" id="expected_date" onClick={handleCheckboxChange} checked={isBillingChecked} />
                          </div>
                        </div>
                        {isBillingChecked === true && (
                          <>
                            <Row>
                              {(isFieldEnabled("Customer") || showMoreInfo) && (
                                <Col md={6} style={{ marginTop: "16px" }}>
                                  <p
                                    style={{
                                      fontFamily: "Satoshi",
                                      fontSize: "13px",
                                      fontWeight: "500",
                                      lineHeight: "17.55px",
                                      color: "#212129",
                                      marginBottom: "8px",
                                      maxWidth: "100%",
                                    }}
                                  >
                                    {renderFieldLabel("Customer", getFieldLabel("Client Name", "Customer"))}
                                  </p>

                                  {<SearchWithAPI onDropdownChange={handleCustomerDropdownChange} apiUrl={`get_client`} placeholder={getFieldLabel("Customer", getFieldLabel("Client Name", "Customer"))} selectedValue={selectedCustomerOption != null ? selectedCustomerOption.label : ""} selectedOption={selectedCustomerOption} />}

                                  <span
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: 400,
                                      color: "#FF4444",
                                    }}
                                  >
                                    {validations.customer_id}
                                  </span>
                                </Col>
                              )}
                              {(isFieldEnabled("Vendor") || showMoreInfo) && (
                                <Col md={6} style={{ marginTop: "16px" }}>
                                  <p
                                    style={{
                                      fontFamily: "Satoshi",
                                      fontSize: "13px",
                                      fontWeight: "500",
                                      lineHeight: "17.55px",
                                      color: "#212129",
                                      marginBottom: "8px",
                                      maxWidth: "100%",
                                    }}
                                  >
                                    {renderFieldLabel("Vendor", "Vendor")}
                                  </p>

                                  {<SearchWithAPI onDropdownChange={handleVendorDropdownChange} apiUrl={"get_vendor"} placeholder={getFieldLabel("Vendor", "Vendor")} selectedValue={selectedVendorOption != null ? selectedVendorOption.label : ""} selectedOption={selectedVendorOption} />}

                                  <span
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: 400,
                                      color: "#FF4444",
                                    }}
                                  >
                                    {validations.vendor_id}
                                  </span>
                                </Col>
                              )}
                              {(isFieldEnabled("Reference") || showMoreInfo) && (
                                <Col md={6} style={{ marginTop: "16px" }}>
                                  <p
                                    style={{
                                      fontFamily: "Satoshi",
                                      fontSize: "13px",
                                      fontWeight: "500",
                                      lineHeight: "17.55px",
                                      color: "#212129",
                                      marginBottom: "8px",
                                      maxWidth: "100%",
                                    }}
                                  >
                                    {renderFieldLabel("Reference", "Reference")}
                                  </p>

                                  {<SearchWithAPI onDropdownChange={handleRefernceDropdownChange} apiUrl={"get_refrences"} params={getReferenceParams()} placeholder={getFieldLabel("Reference", "Reference")} selectedValue={selectedReferenceOption != null ? selectedReferenceOption.label : ""} selectedOption={selectedReferenceOption} />}

                                  <span
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: 400,
                                      color: "#FF4444",
                                    }}
                                  >
                                    {validations.reference_id}
                                  </span>
                                </Col>
                              )}
                            </Row>
                            <Row></Row>
                          </>
                        )}
                      </div>
                    </>))} */}
                    {renderField("Attachment", (<>
                      <Col
                        xs={12}
                        style={
                          isInMoreInfo("Attachment")
                            ? { marginTop: "16px" }
                            : {
                                borderRadius: "16px",
                                padding: "16px",
                                backgroundColor: "#FFFFFF",
                                marginTop: "16px",
                              }
                        }
                      >
                        <div>
                          <div
                            style={{
                              fontFamily: "Satoshi",
                              fontSize: isInMoreInfo("Attachment") ? "13px" : "16px",
                              fontWeight: isInMoreInfo("Attachment") ? "500" : "700",
                              lineHeight: "21.6px",
                              color: "#212129",
                              marginBottom: isInMoreInfo("Attachment") ? "8px" : "0",
                              maxWidth: "100%",
                            }}
                          >
                            {renderFieldLabel("Attachment", "Attachment")}
                          </div>
                        </div>
                        <span
                          style={{
                            fontSize: "12px",
                            fontWeight: 400,
                            color: "#FF4444",
                          }}
                        >
                          {validations.attachments}
                        </span>
                        <div>
                          <label
                            onDragOver={handleDragOver}
                            onDrop={handleDrop}
                            style={{
                              fontFamily: "Satoshi",
                              height: "140px",
                              borderRadius: "8px",
                              border: "1px dashed #212129",
                              gap: "12px",
                              padding: "52px 12px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              fontSize: "15px",
                              fontWeight: "500",
                              lineHeight: "17.17px",
                              color: "#212129",
                              cursor: "pointer",
                              backgroundColor: "#F3F4F6",
                            }}
                            htmlFor="file-upload"
                          >
                            Click here to select or drag an image file{" "}
                          </label>
                          <input type="file" id="file-upload" style={{ display: "none" }} onChange={handleFileChange} />
                        </div>
                        {attachmentURLList.length > 0 && (
                          <div
                            style={{
                              marginTop: "16px",
                              display: "flex",
                              flexWrap: "wrap",
                              justifyContent: "space-between",
                              gap: "16px",
                            }}
                          >
                            {attachmentURLList.map((item, attachIndex) => (
                              <div
                                onClick={() => {
                                  if (isImageAttachment(item)) {
                                    openImagePreview(item);
                                  }
                                }}
                                style={{
                                  width: "312px",
                                  height: "62px",
                                  borderRadius: "12px",
                                  padding: "12px 16px 12px 16px",
                                  backgroundColor: "#F7F7F7",
                                  display: "flex",
                                  alignItems: "center",
                                  cursor: isImageAttachment(item) ? "pointer" : "default",
                                }}
                              >
                                <img src={getAttachmentIcon(item)} style={{ width: "37px", height: "36px" }} />
                                <div
                                  style={{
                                    width: "240px",
                                    marginLeft: "8px",
                                    marginTop: "4px",
                                  }}
                                >
                                  <span
                                    style={{
                                      fontFamily: "Satoshi",
                                      fontWeight: "500px",
                                      fontSize: "13px",
                                      lineHeight: "17.55px",
                                      color: "#212129",
                                      marginBottom: "2px",
                                    }}
                                  >
                                    {item.name}
                                  </span>
                                  <br />
                                  <p
                                    style={{
                                      fontFamily: "Satoshi",
                                      fontWeight: "400px",
                                      fontSize: "12px",
                                      lineHeight: "16.2px",
                                      color: "#8790A1",
                                    }}
                                  >
                                    {item.size}
                                  </p>
                                </div>

                                {item.url && (
                                  <div
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      downloadFile(item.url, item.name);
                                    }}
                                    style={{
                                      width: "32px",
                                      height: "32px",
                                      borderRadius: "100px",
                                    }}
                                  >
                                    <img
                                      src={download}
                                      style={{
                                        width: "12.8px",
                                        height: "12px",
                                        top: "10px",
                                        left: "9.6px",
                                      }}
                                    />
                                  </div>
                                )}

                                <div
                                  style={{
                                    position: "relative",
                                    width: "32px",
                                    height: "32px",
                                    borderRadius: "100px",
                                    marginLeft: "4px",
                                  }}
                                >
                                  <img
                                    src={set}
                                    style={{
                                      width: "12.8px",
                                      height: "12px",
                                      top: "10px",
                                      left: "9.6px",
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setAlertIndex(attachIndex === alertIndex ? null : attachIndex);
                                    }}
                                  />
                                  {alertIndex === attachIndex && (
                                    <div
                                      ref={alertRef}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                      }}
                                      style={{
                                        position: "absolute",
                                        top: "40px",
                                        left: "50%",
                                        transform: "translateX(-50%)",
                                        backgroundColor: "#ffffff",
                                        color: "#1E1E1E",
                                        padding: "16px",
                                        borderRadius: "16px",
                                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                        zIndex: 1,
                                        alignItems: "end",
                                      }}
                                    >
                                      <div
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          removeAttachment(item.id);
                                        }}
                                        style={{
                                          cursor: "pointer",
                                          width: "150px",
                                          height: "36px",
                                          fontSize: "14px",
                                          fontWeight: "500",
                                          color: "#1E1E1E",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "start",
                                        }}
                                      >
                                        Delete
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                        {attachmentList.length > 0 && (
                          <div
                            style={{
                              marginTop: "16px",
                              display: "flex",
                              flexWrap: "wrap",
                              justifyContent: "space-between",
                              gap: "16px",
                            }}
                          >
                            {attachmentList.map((item, attachIndex) => (
                              <div
                                onClick={() => {
                                  if (isImageAttachment(item)) {
                                    openImagePreview(item);
                                  }
                                }}
                                style={{
                                  width: "312px",
                                  height: "62px",
                                  borderRadius: "12px",
                                  padding: "12px 16px 12px 16px",
                                  backgroundColor: "#F7F7F7",
                                  display: "flex",
                                  alignItems: "center",
                                  cursor: isImageAttachment(item) ? "pointer" : "default",
                                }}
                              >
                                <img src={getAttachmentIcon(item)} style={{ width: "37px", height: "36px" }} />
                                <div
                                  style={{
                                    width: "210px",
                                    marginLeft: "8px",
                                    marginTop: "4px",
                                  }}
                                >
                                  <div
                                    style={{
                                      overflow: "hidden",
                                      whiteSpace: "nowrap",
                                      textOverflow: "ellipsis",
                                      fontFamily: "Satoshi",
                                      fontWeight: "500px",
                                      fontSize: "13px",
                                      lineHeight: "17.55px",
                                      color: "#212129",
                                      marginBottom: "2px",
                                    }}
                                  >
                                    {item.name}
                                  </div>
                                  <p
                                    style={{
                                      fontFamily: "Satoshi",
                                      fontWeight: "400px",
                                      fontSize: "12px",
                                      lineHeight: "16.2px",
                                      color: "#8790A1",
                                    }}
                                  >
                                    {item.size}
                                  </p>
                                </div>

                                <div
                                  style={{
                                    position: "relative",
                                    width: "32px",
                                    height: "32px",
                                    borderRadius: "100px",
                                    marginLeft: "4px",
                                  }}
                                >
                                  <img
                                    src={set}
                                    style={{
                                      width: "12.8px",
                                      height: "12px",
                                      top: "10px",
                                      left: "9.6px",
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setAlertIndex(attachIndex === alertIndex ? null : attachIndex);
                                    }}
                                  />
                                  {alertIndex === attachIndex && (
                                    <div
                                      ref={alertRef}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                      }}
                                      style={{
                                        position: "absolute",
                                        top: "10px",
                                        left: "50%",
                                        transform: "translateX(-50%)",
                                        backgroundColor: "#ffffff",
                                        color: "#1E1E1E",
                                        padding: "12px",
                                        borderRadius: "16px",
                                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                        zIndex: 1,
                                        alignItems: "end",
                                      }}
                                    >
                                      <div
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setAttachmentList(attachmentList.filter((_, i) => i !== attachIndex));
                                          setAlertIndex(-1);
                                        }}
                                        style={{
                                          cursor: "pointer",
                                          width: "150px",
                                          height: "36px",
                                          fontSize: "14px",
                                          fontWeight: "500",
                                          color: "#1E1E1E",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "start",
                                        }}
                                      >
                                        Delete
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </Col>
                    </>))}
                  </Col>
                  <Col md={12} lg={6}>
                  {(() => {
                    const otherDetailsFields = (
                      <>
                        {renderField("Customer", (
                          <Col md={6} xxl={4} style={{ marginTop: "16px" }}>
                            <p
                              style={{
                                fontFamily: "Satoshi",
                                fontSize: "13px",
                                fontWeight: "500",
                                lineHeight: "17.55px",
                                color: "#212129",
                                marginBottom: "8px",
                                maxWidth: "100%",
                              }}
                            >
                              {renderFieldLabel("Customer", getFieldLabel("Client Name", "Customer"))}
                            </p>

                            <SearchWithAPI onDropdownChange={handleCustomerDropdownChange} apiUrl={`get_client`} placeholder={getFieldLabel("Customer", getFieldLabel("Client Name", "Customer"))} selectedValue={selectedCustomerOption != null ? selectedCustomerOption.label : ""} selectedOption={selectedCustomerOption} />
                            <span
                              style={{
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "#FF4444",
                              }}
                            >
                              {validations.customer_id}
                            </span>
                          </Col>
                        ))}
                        {renderField("Vendor", (
                          <Col md={6} xxl={4} style={{ marginTop: "16px" }}>
                            <p
                              style={{
                                fontFamily: "Satoshi",
                                fontSize: "13px",
                                fontWeight: "500",
                                lineHeight: "17.55px",
                                color: "#212129",
                                marginBottom: "8px",
                                maxWidth: "100%",
                              }}
                            >
                              {renderFieldLabel("Vendor", "Vendor")}
                            </p>
                            <SearchWithAPI onDropdownChange={handleVendorDropdownChange} apiUrl={"get_vendor"} placeholder={getFieldLabel("Vendor", "Vendor")} selectedValue={selectedVendorOption != null ? selectedVendorOption.label : ""} selectedOption={selectedVendorOption} />
                            <span
                              style={{
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "#FF4444",
                              }}
                            >
                              {validations.vendor_id}
                            </span>
                          </Col>
                        ))}
                        {renderField("Project", (
                          <Col md={6} xxl={4} style={{ marginTop: "16px" }}>
                            <p
                              style={{
                                fontFamily: "Satoshi",
                                fontSize: "13px",
                                fontWeight: "500",
                                lineHeight: "17.55px",
                                color: "#212129",
                                marginBottom: "8px",
                                maxWidth: "100%",
                              }}
                            >
                              {renderFieldLabel("Project", "Project")}
                            </p>
                            <SearchWithAPI
                              params={{
                                client_id: (selectedCustomerOption && selectedCustomerOption.value) ?? "",
                              }}
                              onDropdownChange={handleProjectDropdownChange}
                              apiUrl={`get_project`}
                              placeholder={getFieldLabel("Project", "Project")}
                              selectedValue={selectedProjectOption != null ? selectedProjectOption.label : ""}
                              selectedOption={selectedProjectOption}
                            />
                            <span
                              style={{
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "#FF4444",
                              }}
                            >
                              {validations.project_id}
                            </span>
                          </Col>
                        ))}
                        {renderField("Level", (
                          <>
                            {levelOptionList.map((levelOption, index) => (
                              <Col md={6} xxl={4} key={"level-opt-" + index} style={{ marginTop: "16px" }}>
                                <p
                                  style={{
                                    fontFamily: "Satoshi",
                                    fontSize: "13px",
                                    fontWeight: "500",
                                    lineHeight: "17.55px",
                                    color: "#212129",
                                    marginBottom: "8px",
                                    maxWidth: "100%",
                                  }}
                                >
                                  {renderFieldLabel(
                                    "Level",
                                    `${getFieldLabel("Level", "Level")} ${index + 1}`,
                                    null,
                                    null,
                                    index === 0 && isFieldMandatory("Level")
                                  )}
                                </p>
                                <SearchWithAPI searchId={index} onChangeIndex={{ parentIndex: index }} onDropdownChange={handleLevelListDropdownChange} apiUrl={index === 0 ? "get_parent_component" : "get_child_component"} params={getLevelParams(index)} placeholder={"Search"} selectedValue={levelOption != null ? levelOption.label : ""} selectedOption={levelOption} />
                                {index === 0 && (
                                  <span
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: 400,
                                      color: "#FF4444",
                                    }}
                                  >
                                    {validations.component_id}
                                  </span>
                                )}
                              </Col>
                            ))}
                          </>
                        ))}
                      </>
                    );

                    const priorityField = renderField("Priority", (
                      isInMoreInfo("Priority") ? (
                        <Col md={6} xxl={4} style={{ marginTop: "16px" }}>
                          <p
                            style={{
                              fontFamily: "Satoshi",
                              fontSize: "13px",
                              fontWeight: "500",
                              lineHeight: "17.55px",
                              color: "#212129",
                              marginBottom: "8px",
                              maxWidth: "100%",
                            }}
                          >
                            {renderFieldLabel("Priority", "Priority")}
                          </p>
                          <select
                            className="w-100"
                            id="priority"
                            value={priority}
                            onChange={(event) => {
                              setPriority(event.target.value);
                            }}
                            style={{
                              fontFamily: "Satoshi",
                              fontSize: "14px",
                              fontWeight: "500",
                              lineHeight: "18.9px",
                              color: "#212129",
                              height: "40px",
                              borderRadius: "10px",
                              border: "0.7px solid #E5E5E5",
                              padding: "0 16px",
                              backgroundColor: "#FFFFFF",
                            }}
                          >
                            <option value="Low">Low</option>
                            <option value="Medium">Medium</option>
                            <option value="High">High</option>
                          </select>
                          <span
                            style={{
                              fontSize: "12px",
                              fontWeight: 400,
                              color: "#FF4444",
                            }}
                          >
                            {validations.priority}
                          </span>
                        </Col>
                      ) : (
                        <div style={{ gap: "16px" }}>
                          <select
                            className="w-100"
                            id="priority"
                            value={priority}
                            onChange={(event) => {
                              setPriority(event.target.value);
                            }}
                            style={{
                              fontFamily: "Satoshi",
                              fontSize: "14px",
                              fontWeight: "500",
                              lineHeight: "18.9px",
                              color: "#212129",
                              height: "36px",
                              borderRadius: "10px",
                              border: "0.7px solid #F3F4F6",
                              padding: "0 16px",
                              gap: "77px",
                              backgroundColor: "#F3F4F6",
                            }}
                          >
                            <option value="Low">
                              <span
                                style={{
                                  width: "10px",
                                  height: "10px",
                                  color: "#20824A",
                                }}
                              ></span>
                              Low
                            </option>
                            <option value="Medium">Medium</option>
                            <option value="High">High</option>
                          </select>
                          <span
                            style={{
                              fontSize: "12px",
                              fontWeight: 400,
                              color: "#FF4444",
                            }}
                          >
                            {validations.priority}
                          </span>
                        </div>
                      )
                    ));

                    if (anyFieldConfigured("Priority", "Customer", "Vendor", "Project", "Level")) {
                      return (
                        <div
                          style={{
                            borderRadius: "16px",
                            padding: "16px",
                            gap: "24px",
                            backgroundColor: "#FFFFFF",
                            marginTop: "16px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              gap: "24px",
                            }}
                          >
                            <div
                              style={{
                                fontFamily: "Satoshi",
                                fontSize: "16px",
                                fontWeight: "700",
                                lineHeight: "21.6px",
                                color: "#212129",
                              }}
                            >
                              Other Details
                            </div>
                            {priorityField}
                          </div>

                          <Row>
                            {otherDetailsFields}
                          </Row>
                        </div>
                      );
                    }

                    return (
                      <>
                        {priorityField}
                        {otherDetailsFields}
                      </>
                    );
                  })()}

                    {isApprovalAvail && (
                      <div
                        style={{
                          borderRadius: "16px",
                          padding: "16px",
                          gap: "24px",
                          backgroundColor: "#FFFFFF",
                          marginTop: "16px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <div
                            onClick={() => {
                              setisApprovalSaveAvail(!isApprovalSaveAvail);
                            }}
                            style={{
                              fontFamily: "Satoshi",
                              fontSize: "16px",
                              fontWeight: "900",
                              lineHeight: "21.6px",
                              color: "#212129",
                            }}
                          >
                            Is Approval needed?
                          </div>
                          <div>
                            <input type="checkbox" id="isApprovalNeeded" onClick={handleApprovCheckboxChange} checked={isApprovalSaveAvail} />
                          </div>
                        </div>
                      </div>
                    )}

                    {(() => {
                      const fields = (
                        <>
                          {renderField("Estimation", (
                            <Col md={isInMoreInfo("Estimation") ? 6 : 2} xxl={isInMoreInfo("Estimation") ? 4 : 2} className={isInMoreInfo("Estimation") ? "" : "pe-0"} style={isInMoreInfo("Estimation") ? { marginTop: "16px" } : {}}>
                              <p
                                style={{
                                  fontFamily: "Satoshi",
                                  fontSize: "13px",
                                  fontWeight: "500",
                                  lineHeight: "17.55px",
                                  color: "#212129",
                                  marginBottom: "8px",
                                  maxWidth: "100%",
                                }}
                              >
                                {renderFieldLabel("Estimation", "Estimation")}
                              </p>
                              <input
                                className="w-100"
                                id="est"
                                type="text"
                                value={estimation}
                                onChange={(event) => {
                                  const inputText = event.target.value;
                                  if (/^\d{0,2}(:\d{0,2})?$/.test(inputText)) {
                                    console.log(event.key);
                                    let nextEstimation = inputText;
                                    if (lastKey === "Backspace") {
                                      nextEstimation = inputText;
                                    } else {
                                      nextEstimation = inputText.length === 2 ? inputText + ":" : inputText;
                                    }

                                    setEstimation(nextEstimation);

                                    const calculatedExpected = getExpectedDateFromCreateAndEstimation(createDate, nextEstimation);
                                    if (calculatedExpected) {
                                      setExpectedDate(calculatedExpected);
                                    }
                                  }
                                }}
                                onKeyDown={(event) => {
                                  setLastKey(event.key);
                                }}
                                style={{
                                  height: "44px",
                                  borderRadius: "10px",
                                  gap: "77px",
                                  padding: "16px",
                                  border: "0.7px solid #E5E5E5",
                                  fontFamily: "Satoshi",
                                  fontWeight: "500px",
                                  fontSize: "14px",
                                  lineHeight: "18.9px",
                                  color: "#21272C",
                                  backgroundColor: "#FFFFFF",
                                }}
                                placeholder="hh:mm"
                                maxLength={5}
                              />
                              <span
                                style={{
                                  fontSize: "12px",
                                  fontWeight: 400,
                                  color: "#FF4444",
                                }}
                              >
                                {validations.est}
                              </span>
                            </Col>
                          ))}
                          {renderField("Create Date", (
                            <Col md={isInMoreInfo("Create Date") ? 6 : 5} xxl={isInMoreInfo("Create Date") ? 4 : 5} className={isInMoreInfo("Create Date") ? "" : "pe-0"} style={isInMoreInfo("Create Date") ? { marginTop: "16px" } : {}}>
                              <p
                                style={{
                                  fontFamily: "Satoshi",
                                  fontSize: "13px",
                                  fontWeight: "500",
                                  lineHeight: "17.55px",
                                  color: "#212129",
                                  marginBottom: "8px",
                                  maxWidth: "100%",
                                }}
                              >
                                {renderFieldLabel("Create Date", "Create Date")}
                              </p>
                              <DatePicker selected={createDate ? new Date(createDate) : null} onChange={handleCreateDateChange} showTimeInput timeInputLabel="Enter Time:" dateFormat="dd-MM-yyyy hh:mm aa" minDate={new Date()} placeholderText="dd-mm-yyyy hh:mm am/pm" wrapperClassName="w-100" popperClassName="expected-date-popper" portalId="portal-root" customInput={<ExpectedDateCustomInput />} />
                              <span
                                style={{
                                  fontSize: "12px",
                                  fontWeight: 400,
                                  color: "#FF4444",
                                }}
                              >
                                {validations.created}
                              </span>
                            </Col>
                          ))}
                          {renderField("Expected Date", (
                            <Col md={isInMoreInfo("Expected Date") ? 6 : 5} xxl={isInMoreInfo("Expected Date") ? 4 : 5} style={isInMoreInfo("Expected Date") ? { marginTop: "16px" } : {}}>
                              <p
                                style={{
                                  fontFamily: "Satoshi",
                                  fontSize: "13px",
                                  fontWeight: "500",
                                  lineHeight: "17.55px",
                                  color: "#212129",
                                  marginBottom: "8px",
                                  maxWidth: "100%",
                                }}
                              >
                                {renderFieldLabel("Expected Date", "Expected Date")}
                              </p>
                              <DatePicker selected={expectedDate ? new Date(expectedDate) : null} onChange={handleExpectedDateChange} showTimeInput timeInputLabel="Enter Time:" dateFormat="dd-MM-yyyy hh:mm aa" minDate={createDate ? new Date(createDate) : null} placeholderText="dd-mm-yyyy hh:mm am/pm" wrapperClassName="w-100" popperClassName="expected-date-popper" portalId="portal-root" customInput={<ExpectedDateCustomInput />} />
                              <span
                                style={{
                                  fontSize: "12px",
                                  fontWeight: 400,
                                  color: "#FF4444",
                                }}
                              >
                                {validations.expected}
                              </span>
                            </Col>
                          ))}
                        </>
                      );

                      if (anyFieldConfigured("Estimation", "Create Date", "Expected Date")) {
                        return (
                          <div
                            style={{
                              borderRadius: "16px",
                              padding: "16px",
                              gap: "24px",
                              backgroundColor: "#FFFFFF",
                              marginTop: "16px",
                            }}
                          >
                            <Row>{fields}</Row>
                          </div>
                        );
                      }
                      return fields;
                    })()}

                    {(() => {
                      const fields = (
                        <>
                          {renderField("Reporter", (
                            <Col md={isInMoreInfo("Reporter") ? 6 : 12} xxl={isInMoreInfo("Reporter") ? 4 : 12} style={{ marginTop: isInMoreInfo("Reporter") ? "16px" : "0" }}>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  minHeight: "36px",
                                  marginBottom: "8px",
                                }}
                              >
                                <p
                                  style={{
                                    fontFamily: "Satoshi",
                                    fontSize: "13px",
                                    fontWeight: "500",
                                    lineHeight: "17.55px",
                                    color: "#212129",
                                    marginBottom: "0",
                                    flex: 1,
                                    minWidth: 0,
                                    marginRight: "8px",
                                  }}
                                >
                                  {renderFieldLabel("Reporter", "Reporter")}
                                </p>
                                <label
                                  htmlFor="self_assign"
                                  className="style-justify-center"
                                  style={{
                                    marginBottom: "0",
                                    height: "32px",
                                    borderRadius: "100px",
                                    padding: "6px 14px",
                                    gap: "6px",
                                    backgroundColor: "#F0E8FF",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    cursor: "pointer",
                                    fontFamily: "Satoshi",
                                    fontSize: "13px",
                                    fontWeight: "700",
                                    lineHeight: "18.9px",
                                    color: "#6929E2",
                                    border: "none",
                                    marginLeft: "8px",
                                    flexShrink: 0,
                                  }}
                                >
                                  <input
                                    type="checkbox"
                                    id="self_assign"
                                    checked={isSelfAssignChecked}
                                    onChange={(e) => {
                                      setIsSelfAssignChecked(e.target.checked);
                                      getSelfAssignee(e.target.checked ? "self" : "last");
                                    }}
                                    style={{ cursor: "pointer" }}
                                  />
                                  <span className="ms-1">Self Assign</span>
                                </label>
                              </div>
                              <SearchWithAPI
                                onDropdownChange={handleEmailDropdownChange}
                                apiUrl={"get_employee"}
                                params={{}}
                                placeholder={"Email"}
                                selectedValue={selectedEmailOption != null ? selectedEmailOption.label : ""}
                                selectedOption={selectedEmailOption}
                              />
                              <span
                                style={{
                                  fontSize: "12px",
                                  fontWeight: 400,
                                  color: "#FF4444",
                                }}
                              >
                                {validations.reporter_id}
                              </span>
                            </Col>
                          ))}

                          {renderField("Team", (
                            <Col md={isInMoreInfo("Team") ? 6 : 12} xxl={isInMoreInfo("Team") ? 4 : 12} style={{ marginTop: "16px" }}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  minHeight: "36px",
                                  marginBottom: "8px",
                                }}
                              >
                                <p
                                  style={{
                                    fontFamily: "Satoshi",
                                    fontSize: "13px",
                                    fontWeight: "500",
                                    lineHeight: "17.55px",
                                    color: "#212129",
                                    marginBottom: "0",
                                    maxWidth: "100%",
                                  }}
                                >
                                  {renderFieldLabel("Team", "Team")}
                                </p>
                              </div>
                              <SearchWithAPI
                                onDropdownChange={handleTeamDropdownChange}
                                apiUrl={"get_team"}
                                placeholder={getFieldLabel("Team", "Team")}
                                selectedValue={selectedTeamOption != null ? selectedTeamOption.label : ""}
                                selectedOption={selectedTeamOption}
                              />
                              <span
                                style={{
                                  fontSize: "12px",
                                  fontWeight: 400,
                                  color: "#FF4444",
                                }}
                              >
                                {validations.team_id}
                              </span>
                            </Col>
                          ))}

                          {renderField("Assign To", (
                            <Col md={isInMoreInfo("Assign To") ? 6 : 12} xxl={isInMoreInfo("Assign To") ? 4 : 12} style={{ marginTop: "16px" }}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  minHeight: "36px",
                                  marginBottom: "8px",
                                }}
                              >
                                <p
                                  style={{
                                    fontFamily: "Satoshi",
                                    fontSize: "13px",
                                    fontWeight: "500",
                                    lineHeight: "17.55px",
                                    color: "#212129",
                                    marginBottom: "0",
                                    maxWidth: "100%",
                                  }}
                                >
                                  {renderFieldLabel("Assign To", "Assign To")}
                                </p>
                              </div>
                              <SearchWithAPI
                                onDropdownChange={handleAssignToDropdownChange}
                                apiUrl={"get_employee"}
                                params={{
                                  team_id: (selectedTeamOption && selectedTeamOption.value) ?? "",
                                }}
                                placeholder={getFieldLabel("Assign To", "Assign To")}
                                selectedValue={selectedAssignToOption != null ? selectedAssignToOption.label : ""}
                                selectedOption={selectedAssignToOption}
                              />
                              <span
                                style={{
                                  fontSize: "12px",
                                  fontWeight: 400,
                                  color: "#FF4444",
                                }}
                              >
                                {validations.assignee}
                              </span>
                            </Col>
                          ))}
                        </>
                      );

                      if (anyFieldConfigured("Reporter", "Team", "Assign To")) {
                        return (
                          <div
                            style={{
                              borderRadius: "16px",
                              padding: "16px",
                              gap: "24px",
                              backgroundColor: "#FFFFFF",
                              marginTop: "16px",
                            }}
                          >
                            <Row>{fields}</Row>
                          </div>
                        );
                      }
                      return fields;
                    })()}

                    {/* More Information card: when checked, fields that are not
                        enabled in the configuration are portaled into the body
                        below (see MoreInfoSlot). */}
                    {hasUnconfiguredFields && (
                      <div
                        style={{
                          borderRadius: "16px",
                          padding: "16px",
                          backgroundColor: "#FFFFFF",
                          marginTop: "16px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            cursor: "pointer",
                          }}
                          onClick={() => setShowMoreInfo((prev) => !prev)}
                        >
                          <span
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "700",
                              fontSize: "16px",
                              lineHeight: "22px",
                              color: "#212129",
                            }}
                          >
                            More Information
                          </span>
                          <input
                            type="checkbox"
                            checked={showMoreInfo}
                            onChange={(e) => setShowMoreInfo(e.target.checked)}
                            onClick={(e) => e.stopPropagation()}
                            style={{
                              width: "20px",
                              height: "20px",
                              borderRadius: "6px",
                              border: "1px solid #C9CDD6",
                              accentColor: "#6929E2",
                              cursor: "pointer",
                            }}
                          />
                        </div>
                        {/* Portal target for not-configured fields. */}
                        <Row
                          ref={setMoreInfoNode}
                          style={{
                            marginTop: showMoreInfo ? "8px" : "0",
                            display: showMoreInfo ? "flex" : "none",
                          }}
                        />
                      </div>
                    )}
                  </Col>
                </Row>
              </Col>
            </div>
          </Col>
        </Row>
        {/* <BulkEditCard /> */}
      </div>

      {isOpenParentTicket && (
        <div style={parentTicketModalStyle.overlay}>
          <div style={parentTicketModalStyle.modal}>
            <div style={{ color: "#ffffff" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  <div
                    style={{
                      paddingLeft: "4px",
                      fontSize: "20px",
                      fontWeight: "500",
                      color: "#212129",
                    }}
                  >
                    Select parent ticket
                  </div>
                </div>
                <ModalCloseIcon style={{ cursor: "pointer" }} onClick={closePatentTicketModal} />
              </div>

              <div>
                {selectedParentTicketOption === null && (
                  <div style={{ marginTop: "24px" }}>
                    <div>
                      <p
                        style={{
                          fontFamily: "Satoshi",
                          fontSize: "13px",
                          fontWeight: "500",
                          lineHeight: "17.55px",
                          color: "#212129",
                          marginBottom: "8px",
                          textAlign: "left",
                        }}
                      >
                        Search parent ticket
                      </p>
                      <SearchWithAPI onDropdownChange={handleParentTicketDropdownChange} apiUrl={"get_main_tickets"} placeholder={"Search"} selectedValue={selectedParentTicketOption != null ? selectedParentTicketOption.label : ""} selectedOption={selectedParentTicketOption} />
                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                        }}
                      >
                        {validations.description}
                      </span>
                    </div>
                  </div>
                )}
                {selectedParentTicketOption != null && (
                  <div style={{ marginTop: "24px" }}>
                    <div>
                      <p
                        style={{
                          fontFamily: "Satoshi",
                          fontSize: "13px",
                          fontWeight: "500",
                          lineHeight: "17.55px",
                          color: "#6929E2",
                          marginBottom: "8px",
                          textAlign: "left",
                        }}
                      >
                        Parent ticket
                      </p>
                      <div
                        style={{
                          height: "55px",
                          padding: "12px",
                          borderRadius: "16px",
                          background: "#F7F2FF",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "start",
                            }}
                          >
                            <div
                              style={{
                                height: "11px",
                                borderRight: "2px solid #6929E2",
                              }}
                            ></div>
                            <div
                              style={{
                                marginLeft: "12px",
                                fontFamily: "Satoshi",
                                fontSize: "14px",
                                fontWeight: "500",
                                color: "#212129",
                              }}
                            >
                              {selectedParentTicketOption.label}
                            </div>
                          </div>
                          <div
                            onClick={() => {
                              setParentTicketOption(null);
                              setParentTicketDetails(null);
                              setModuleOption(null);
                              setIsBillingChecked(false);
                            }}
                            style={{
                              padding: "7px 10px",
                              borderRadius: "100px",
                              background: "#ffffff",
                            }}
                          >
                            <div
                              style={{
                                fontFamily: "Satoshi",
                                fontSize: "12.5px",
                                fontWeight: "500",
                                color: "#212129",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              {" "}
                              <img
                                src={deleteIcon}
                                style={{
                                  width: "14px",
                                  height: "14px",
                                  marginRight: "8px",
                                }}
                                alt="Remove"
                              />{" "}
                              Remove
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <Row
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "end",
                    marginTop: "16px",
                  }}
                >
                  <div
                    onClick={(e) => {
                      closePatentTicketModal();
                    }}
                    style={{
                      cursor: "pointer",
                      width: "95px",
                      height: "44px",
                      marginLeft: "8px",
                      marginRight: "8px",
                      borderRadius: "8px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#FFFFFF",
                      border: "0.6px solid #E5E5E5",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "700",
                        color: "#1E1E1E",
                      }}
                    >
                      Cancel
                    </div>
                  </div>
                  {/*  <div
                    onClick={ (e) => {


                    }}
                    style={{
                      cursor: "pointer",
                      width: "176px",
                      height: "44px",
                      marginLeft: "8px",
                      marginRight: "8px",
                      borderRadius: "8px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#6929E2",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "700",
                        color: "#FFFFFF",
                      }}
                    >
                      Submit
                    </div>
                  </div> */}
                </Row>
              </div>
            </div>
          </div>
        </div>
      )}

      {isImagePreviewOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1200,
            padding: "16px",
          }}
          onClick={closeImagePreview}
        >
          <div
            style={{
              position: "relative",
              width: "min(90vw, 1200px)",
              maxHeight: "90vh",
              backgroundColor: "#FFFFFF",
              borderRadius: "12px",
              padding: "12px",
              display: "flex",
              flexDirection: "column",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "8px",
              }}
            >
              <span
                style={{
                  fontFamily: "Satoshi",
                  fontWeight: "700",
                  fontSize: "14px",
                  color: "#212129",
                  maxWidth: "calc(100% - 40px)",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
                title={previewImageName}
              >
                {previewImageName}
              </span>
              <button
                type="button"
                onClick={closeImagePreview}
                style={{
                  border: "none",
                  background: "transparent",
                  fontSize: "22px",
                  lineHeight: 1,
                  cursor: "pointer",
                  color: "#212129",
                }}
              >
                x
              </button>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                overflow: "auto",
              }}
            >
              <img
                src={previewImageUrl}
                alt={previewImageName || "attachment preview"}
                style={{
                  maxWidth: "100%",
                  maxHeight: "calc(90vh - 80px)",
                  objectFit: "contain",
                }}
                onError={closeImagePreview}
              />
            </div>
          </div>
        </div>
      )}

      {showMergeConfirm && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              width: "520px",
              backgroundColor: "#FFFFFF",
              borderRadius: "24px",
              padding: "24px",
              textAlign: "center",
            }}
          >
            <img src={mergeWarning} alt="warning" style={{ height: "96px", marginBottom: "16px" }} />

            <h3
              style={{
                fontFamily: "Satoshi",
                fontSize: "22px",
                fontWeight: "700",
                color: "#212129",
                marginBottom: "16px",
              }}
            >
              Merge Ticket?
            </h3>
            <p
              style={{
                fontFamily: "Satoshi",
                fontSize: "14px",
                fontWeight: "500",
                color: "#81878C",
              }}
            >
              This action cannot be undone, and the changes will be permanent.
            </p>

            <div style={{ display: "flex", gap: "16px", justifyContent: "center" }}>
              <button
                onClick={() => setShowMergeConfirm(false)}
                style={{
                  width: "164px",
                  height: "40px",
                  borderRadius: "100px",
                  border: "1px solid #E5E5E5",
                  background: "transparent",
                  fontFamily: "Satoshi",
                  fontSize: "16px",
                  fontWeight: "700",
                  color: "#212129",
                }}
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  setShowMergeConfirm(false);
                  taskSubmit(true);
                }}
                style={{
                  width: "164px",
                  height: "40px",
                  borderRadius: "100px",
                  border: "none",
                  background: "#6929E2",
                  fontFamily: "Satoshi",
                  fontSize: "16px",
                  fontWeight: "700",
                  color: "#FFFFFF",
                }}
              >
                Yes, Proceed
              </button>
            </div>
          </div>
        </div>
      )}

      <ToastContainer position="top-end">
        <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>
          {/*  <Toast.Header>
            <strong className="mr-auto">Snackbar Title</strong>
          </Toast.Header> */}
          <Toast.Body style={{ color: "#ffffff" }}>{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
      <LoaderModal show={loading} />
    </Container>
  );
};

export default Ticketadd;
